import { Lock, LockOpen } from 'lucide-react';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styled from '@emotion/styled';
import { BarLoader } from 'react-spinners';
import { setActiveBoard } from 'modules/template-editor/store/templates/templates';
import useBoards from '../../../../template-editor/ui/hooks/use-boards';
import EmptyButton from 'ud-ui/components/empty-button';
import { setBoardLocked } from '../../../store/overlay/overlay';
import { selectIsBoardLocked } from '../../../store/overlay/selectors';
import Block from '../components/block';
import Text from '../components/text';

export function Dashboard() {
  const dispatch = useDispatch();
  const { boards, activeBoard } = useBoards();
  const isBoardLocked = useSelector(selectIsBoardLocked);

  const baseCallback = useCallback(
    (newState: number | undefined) => {
      if (newState === activeBoard?.id) {
        dispatch(setActiveBoard({ id: undefined }));
      } else {
        dispatch(setActiveBoard({ id: newState }));
      }
    },
    [activeBoard?.id, dispatch],
  );

  const listItems: ItemType[] | undefined = useMemo(() => {
    const listBoards: ItemType[] = boards
      ?.filter((board) => board.type === 'static' || board.type === 'carousel' || board.type === 'tv')
      .map((board) => {
        return { text: board.name, state: board.id };
      });

    listBoards?.push({ text: 'Выкл.', state: undefined });

    return listBoards;
  }, [boards]);

  const items = useMemo(() => {
    return listItems?.map((item) => {
      const onClick = () => {
        baseCallback(item.state);
      };

      return (
        <Item key={item.text} active={activeBoard?.id === item.state} onClick={onClick} className={'flex-center'}>
          <Text color={'#FFF'} size={'medium'}>
            {item.text}
          </Text>
        </Item>
      );
    });
  }, [activeBoard?.id, baseCallback, listItems]);

  const toggleLock = useCallback(() => {
    dispatch(setBoardLocked(!isBoardLocked));
  }, [dispatch, isBoardLocked]);

  return (
    <Block className={'flex flex-col'} headerText={'Табло'}>
      <EmptyButton
        style={{ position: 'absolute', right: 5, top: 5, zIndex: 1 }}
        onClick={toggleLock}
        color={isBoardLocked ? 'white' : 'gray'}
        icon={isBoardLocked ? <Lock size={16} /> : <LockOpen size={16} />}
      />
      <DashboardList className={'flex'}>
        {boards.length === 0 ? (
          <div className={'flex-center w-full'}>
            <BarLoader width={250} />
          </div>
        ) : (
          items
        )}
      </DashboardList>
    </Block>
  );
}

type ItemType = { text: string; state: number | undefined };

const DashboardList = styled.div`
  gap: 8px;
  flex-wrap: wrap;
`;

const Item = styled.div<{ active: boolean }>`
  padding-inline: 14px;
  padding-block: 4px;
  background: ${({ active }) => (active ? '#D9B244' : '#686a79')};
`;
